import { render, staticRenderFns } from "./common-problem.vue?vue&type=template&id=13a2e156&"
import script from "./common-problem.vue?vue&type=script&lang=js&"
export * from "./common-problem.vue?vue&type=script&lang=js&"
import style0 from "./common-problem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports